import { getAuthToken, handleAuthError } from './auth-client'
import { getApiUrl } from './api-config'

export type NavigateFn = (path: string, options?: { replace?: boolean }) => void

export async function authenticatedFetch(
  url: string,
  options: RequestInit = {},
  navigate?: NavigateFn
): Promise<Response> {
  const token = getAuthToken()
  const headers = new Headers(options.headers)
  if (token) {
    headers.set('Authorization', `Bearer ${token}`)
  }
  const fullUrl = url.startsWith('http') ? url : getApiUrl(url)
  const response = await fetch(fullUrl, { ...options, headers })
  const router = navigate ? { replace: (path: string) => navigate(path, { replace: true }) } : undefined
  const wasHandled = await handleAuthError(response, router)
  if (wasHandled) {
    return new Response(null, { status: 403, statusText: 'Forbidden' })
  }
  return response
}

export async function checkAuthError(
  response: Response,
  router?: { replace: (path: string) => void }
): Promise<boolean> {
  return handleAuthError(response, router)
}
